import React from 'react';
import './Possibility.css';
import possibilityImage from '../../assets/possibility.webp';

const Possibility = () => {
  return (
    <section id='possibility' className='possibility-section'>
      <div className='possibility-container'>

        <div className='possibility-image-container'>
          <img src={possibilityImage} alt="Possibilities" width={500} height={500} />
        </div>

        <div className="possibility-content-container">
          <h4>Request Early Access to Get Started</h4>
          <h1 className="gradient_text">The possibilities are <div>beyond your imagination</div></h1>
          <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>
          <p className='possibility-request-text'>Request Early Access to Get Started</p>
        </div>

      </div>
    </section>
  )
}

export default Possibility
